import { MapPin } from "lucide-react";

const centres = [
  { city: "Visakhapatnam", machines: 42, utilisation: 78 },
  { city: "Vijayawada", machines: 36, utilisation: 71 },
  { city: "Tirupati", machines: 29, utilisation: 65 },
  { city: "Kurnool", machines: 24, utilisation: 58 },
];

export default function SelectCentreStep({ formData, updateField }) {
  return (
    <div className="space-y-4">
      {centres.map(({ city, machines, utilisation }) => {
        const isSelected = formData.centre === city;
        return (
          <button
            key={city}
            type="button"
            onClick={() => updateField("centre", city)}
            className={`w-full flex items-center justify-between text-left border rounded-xl px-5 py-4 transition ${
              isSelected
                ? "border-indigo-500 bg-indigo-50"
                : "border-gray-200 hover:border-indigo-300"
            }`}
          >
            <div>
              <p className="font-bold text-gray-900">APIC {city}</p>
              <p className="flex items-center gap-1 text-sm text-gray-500">
                <MapPin className="w-3.5 h-3.5" /> {city} · {machines} machines
              </p>
            </div>
            <div className="text-right">
              <p className="text-xs text-gray-500">Utilization</p>
              <p className="font-bold text-gray-900">{utilisation}%</p>
            </div>
          </button>
        );
      })}
    </div>
  );
}